import { CdkDrag, CdkDragEnter, CdkDropList, CdkDropListGroup, DragRef, moveItemInArray } from '@angular/cdk/drag-drop'
import { NgFor, NgIf } from '@angular/common'
import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { CollectionItemComponent } from '../../molecules/collection-item/collection-item.component'

@Component({
	selector: 'app-grid',
	templateUrl: './grid.component.html',
	styleUrls: ['./grid.component.scss'],
	standalone: true,
	imports: [NgIf, CdkDropListGroup, NgFor, CdkDropList, CollectionItemComponent, CdkDrag],
})
export class GridComponent implements AfterViewInit {
	@ViewChild(CdkDropList) placeholder: CdkDropList
	private target: CdkDropList = null
	private targetIndex: number
	private source: CdkDropList = null
	private sourceIndex: number
	private dragRef: DragRef = null

	@Input() orderable: boolean = false
	@Output() order = new EventEmitter()
	@Input() items: unknown[]
	@Input() type: string = 'campaign'

	boxWidth = '200px'
	boxHeight = '200px'

	ngAfterViewInit() {
		if (!this.placeholder?.element?.nativeElement) return
		const placeholderElement = this.placeholder.element.nativeElement

		placeholderElement.style.display = 'none'
		placeholderElement.parentNode.removeChild(placeholderElement)
	}

	onDropListDropped() {
		if (!this.target) {
			return
		}

		const placeholderElement: HTMLElement = this.placeholder.element.nativeElement
		const placeholderParentElement: HTMLElement = placeholderElement.parentElement

		placeholderElement.style.display = 'none'

		placeholderParentElement.removeChild(placeholderElement)
		placeholderParentElement.appendChild(placeholderElement)
		placeholderParentElement.insertBefore(
			this.source.element.nativeElement,
			placeholderParentElement.children[this.sourceIndex],
		)

		if (this.placeholder._dropListRef.isDragging()) {
			this.placeholder._dropListRef.exit(this.dragRef)
		}

		this.target = null
		this.source = null
		this.dragRef = null

		if (this.sourceIndex !== this.targetIndex) {
			moveItemInArray(this.items, this.sourceIndex, this.targetIndex)
			this.order.emit(this.items)
		}
	}

	onDropListEntered({ item, container }: CdkDragEnter) {
		if (container == this.placeholder) {
			return
		}

		const placeholderElement: HTMLElement = this.placeholder.element.nativeElement
		const sourceElement: HTMLElement = item.dropContainer.element.nativeElement
		const dropElement: HTMLElement = container.element.nativeElement
		const dragIndex: number = Array.prototype.indexOf.call(
			dropElement.parentElement.children,
			this.source ? placeholderElement : sourceElement,
		)
		const dropIndex: number = Array.prototype.indexOf.call(dropElement.parentElement.children, dropElement)

		if (!this.source) {
			this.sourceIndex = dragIndex
			this.source = item.dropContainer

			placeholderElement.style.width = this.boxWidth + 'px'
			placeholderElement.style.height = this.boxHeight + 40 + 'px'

			sourceElement.parentElement.removeChild(sourceElement)
		}

		this.targetIndex = dropIndex
		this.target = container
		this.dragRef = item._dragRef

		placeholderElement.style.display = ''

		dropElement.parentElement.insertBefore(
			placeholderElement,
			dropIndex > dragIndex ? dropElement.nextSibling : dropElement,
		)

		this.placeholder._dropListRef.enter(
			item._dragRef,
			item.element.nativeElement.offsetLeft,
			item.element.nativeElement.offsetTop,
		)
	}
}
